const getURLParams = () => {
  const paramsObj = {}
  window.location.search
    .replace('?', '')
    .split('&')
    .forEach((param) => {
      const keyValue = param.split('=')
      paramsObj[keyValue[0]] = keyValue[1]
    })

  return paramsObj
}

export default getURLParams
